import isConsumer from "owa-session-store/lib/utils/isConsumer";
import { notifyIfOptionalExperiencesChanged } from "../orchestrators/notifyIfOptionalExperiencesChanged";
import { getFromStoreOrLocalStorageOrStartupData } from "../utils/getFromStoreOrLocalStorageOrStartupData";
import { isOptionalExperiencesAllowedByPolicy } from "../utils/isOptionalExperiencesAllowedByPolicy";
import { isPrivacyEnabled, isPrivacyRoamingEnabled } from "../utils/isPrivacyRoamingEnabled";
import { ocpsLocalStorageUpdated } from "owa-ocps-get-policies/lib/actions/actions";
import { orchestrator } from "satcheljs";
import { setIsOptionalExperiencesPolicyEnabledMutator } from "../mutators/setIsOptionalExperiencesPolicyEnabled";
import { getOptionalExperiencesPolicy } from "../utils/getOptionalExperiencesPolicy";

export function getOptionalExperiencesDisabledForPrivacyAndNotifyValueChanges(): boolean {
    if (!isPrivacyEnabled()) {
        return false;
    }
    
    if (isConsumer()) {
        return false;
    }
    
    const optionalExperiencesEnabled = getFromStoreOrLocalStorageOrStartupData("optionalExperiencesEnabled");
    
    const isOceDisabled = !optionalExperiencesEnabled || !isOptionalExperiencesAllowedByPolicy();
    notifyIfOptionalExperiencesChanged({ isOceDisabled });
    
    return isOceDisabled;
}

// export with the old name to maintain API compatibility
export const isOptionalExperiencesDisabledForPrivacy: () => boolean = getOptionalExperiencesDisabledForPrivacyAndNotifyValueChanges;

// Listening for changes on ocps store
orchestrator(ocpsLocalStorageUpdated, ({ event }) => {
    if (isPrivacyRoamingEnabled() && event === "POLICY") {
        const newPolicyValue = getOptionalExperiencesPolicy();
        setIsOptionalExperiencesPolicyEnabledMutator(newPolicyValue);
        
        getOptionalExperiencesDisabledForPrivacyAndNotifyValueChanges();
    }
});
